module.exports = require("firebase");